<template>
  <div class="typeTwo">
    <div class="two-item" v-for="(item,index) in part2" :key="index">
      <div class="typeTwo-title">{{item.title ||''}}</div>
      <div class="typeTwo-desc">{{item.desc ||''}}</div>
      <div class="typeTwo-btn">{{item.btnText ||''}}</div>
      <div class="img-box-item" v-for="(itemSub,indexSub) in item.imgBox" :key="indexSub">
        <img :style="{width:itemSub.width}" :src="require(`../assets/${itemSub.imgSrc}`)" >
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'typeOne',
    props:{
      part2:{
        type:Array,
        default:[]
      }
    }
  }
</script>

<style scoped lang="less">
  .typeTwo{
    .two-item{
      padding: 30px 0;
      border-bottom: 10px solid #F9F9F9;
      .typeTwo-title{
        font-size: 20px;
        color: #333333;
        text-align: center;
        font-weight: bold;
      }
      .typeTwo-desc{
        width: 68%;
        margin: 0 auto;
        text-align: center;
        font-size: 12px;
        line-height: 26px;
        margin-top: 20px;
      }
      .typeTwo-btn{
        width: 98px;
        height: 26px;
        background-color: #726AF9;
        color: #fff;
        margin: 0 auto;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        margin-bottom: 20px;
      }
      .img-box-item{
        img{
          margin: 0 auto;
          width: 300px;
          display: block;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/typeTwo.vue